import { FieldSwitch } from '@dixa/lib-shared-habla';
import cn from 'classnames';
import * as React from 'react';

import { Csat } from '../../types';

import styles from './index.module.scss';

interface Props {
  isActive: boolean;
  onChange: (change: Csat.CsatStatusChange) => void;
  channel: Csat.SupportedChannels;
  className?: string;
  id?: string;
}

export const CsatToggle: React.FunctionComponent<Props> = ({
  onChange,
  isActive,
  channel,
  className,
  id,
}) => {
  const handleChange = () =>
    onChange({
      channel: channel,
      newStatus: !isActive,
    });

  return (
    <FieldSwitch
      id={id}
      className={cn(styles.switch, className)}
      input={{
        name: channel,
        value: channel,
        checked: isActive,
        onChange: handleChange,
      }}
    />
  );
};
